import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HotToastService } from '@ngneat/hot-toast';
import { Subscription } from 'rxjs';

import { AddShoppingCartItemRequest, ProductDto } from 'src/app/core/dtos/dto';
import { BrandEnum, ProductTypeEnum } from 'src/app/core/dtos/enum';
import { HttpErrorResponseMessages } from 'src/app/core/dtos/http-error-response-messages';
import { ProductService } from 'src/app/core/services/product.service';
import { ShoppingCartService } from 'src/app/core/services/shopping-cart.service';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';
import { ConfigHelper } from '../../../../../core/services/helpers/config.helper';

@Component({
  selector: 'app-product-bundles',
  templateUrl: './product-bundles.component.html',
  styleUrls: ['./product-bundles.component.scss']
})
export class ProductBundlesComponent implements OnInit, OnDestroy {

  @Input() product: ProductDto;
  @Input() brandId: BrandEnum;
  @Input() isRegFlow: boolean;

  productBundlesSubscription: Subscription;
  productBundles: ProductDto[] = [];
  isCelpipPracticeTest = ProductTypeEnum.ElectronicProductOnline;
  productIdToAdd: number;
  addShoppingCartItemRequest: AddShoppingCartItemRequest;
  addItemWarningMesssage: string;
  addProductSubscription: Subscription;
  checkWarningSubscription: Subscription;

  @ViewChild('addItemWarning') addItemWarning: ModalComponent;

  constructor(
    private productService: ProductService,
    private modalService: NgbModal,
    private configHelper: ConfigHelper,
    private shoppingCartService: ShoppingCartService,
    private router: Router,
    private toastService: HotToastService,
  ) { }


  public get BrandEnum() {
    return BrandEnum;
  }

  ngOnInit(): void {
    this.productBundlesSubscription = this.productService.getBundleProductsForProduct(this.product.id, this.product.currencyCode)
      .subscribe(x => {
        this.productBundles = x.content;
        this.productBundles.forEach(p => {
          p.imageUrl = this.configHelper.getProductImageUrl(p.imageUrl);
          p.isPurchasable = true;
        });
      });
  }

  addItemToCart(product: ProductDto) {
    this.productIdToAdd = product.id;
    this.addShoppingCartItemRequest = {
      productId: product.id
    };
    this.checkWarningSubscription = this.shoppingCartService.checkForWarnings(product.id)
      .subscribe(
        (result) => {
          if (result.content === "") {
            this.finalizeAdd();
          }
          else {
            this.addItemWarningMesssage = result.content;
            this.addItemWarning.open();
          }
        }
        ,
        (error: HttpErrorResponse) => {
          if (error.status !== 401) {
            const errorMessage = error.error as HttpErrorResponseMessages;
            if (errorMessage?.reasons) {
              errorMessage.reasons.forEach(reasons => {
                this.toastService.warning(reasons.errorMessage);
              });
            }
          }
        }
      );
  }

  finalizeAdd() {
    this.addProductSubscription = this.shoppingCartService.addProduct(this.addShoppingCartItemRequest)
      .subscribe(
        result => {
          if (this.modalService.hasOpenModals) {
            this.modalService.dismissAll();
          }
          this.shoppingCartService.setShoppingCart(result);
          if (this.isRegFlow) {
            this.router.navigate(['/registration/order-summary']);
          }
          else {
            this.router.navigate(['/shopping-cart']);
          }
        },
        () => {
          this.toastService.warning('Unable to add item to cart');
        });
  }

  ngOnDestroy(): void {
    this.productBundlesSubscription?.unsubscribe();
    this.checkWarningSubscription?.unsubscribe();
    this.addProductSubscription?.unsubscribe();
  }

}
